export const globalSettings = (state) =>
  state.globalSettings === null
    ? state.globalSettings
    : JSON.parse(localStorage.getItem('globalSettings'));
